export const APPAREL_SIZE_OPTIONS = [
  { id: -1, name: '--', value: '' },
  { id: 1, name: 'SM', value: 'SM' },
  { id: 2, name: 'MD', value: 'MD' },
  { id: 3, name: 'LG', value: 'LG' },
  { id: 4, name: 'XL', value: 'XL' },
  { id: 5, name: '2XL', value: '2XL' },
  { id: 6, name: '3XL', value: '3XL' }
];

export const APPAREL_GENDER_OPTIONS = [
  { id: 1, name: `Men's`, value: `M`, displayInDropdown: true },
  { id: 2, name: `Women's`, value: `F`, displayInDropdown: true },
  { id: 3, name: 'Unisex', value: 'U', displayInDropdown: false }
];

export const WOMEN_SHOE_SIZE_OPTIONS = [
  { id: -1, name: '--', value: '' },
  { id: 1, name: `5`, value: `5` },
  { id: 1, name: `5.5`, value: `5.5` },
  { id: 2, name: `6`, value: `6` },
  { id: 3, name: `6.5`, value: `6.5` },
  { id: 4, name: `7`, value: `7` },
  { id: 5, name: `7.5`, value: `7.5` },
  { id: 6, name: `8`, value: `8` },
  { id: 7, name: `8.5`, value: `8.5` },
  { id: 8, name: `9`, value: `9` },
  { id: 9, name: `9.5`, value: `9.5` },
  { id: 10, name: `10`, value: `10` },
  { id: 12, name: `11`, value: `11` },
  { id: 14, name: `12`, value: `12` }
];

export const MEN_SHOE_SIZE_OPTIONS = [
  { id: -1, name: '--', value: '' },
  { id: 1, name: `7.5`, value: `7.5` },
  { id: 2, name: `8`, value: `8` },
  { id: 3, name: `8.5`, value: `8.5` },
  { id: 4, name: `9`, value: `9` },
  { id: 5, name: `9.5`, value: `9.5` },
  { id: 6, name: `10`, value: `10` },
  { id: 7, name: `10.5`, value: `10.5` },
  { id: 8, name: `11`, value: `11` },
  { id: 9, name: `11.5`, value: `11.5` },
  { id: 10, name: `12`, value: `12` },
  { id: 11, name: `12.5`, value: `12.5` },
  { id: 12, name: `13`, value: `13` },
  { id: 13, name: `14`, value: `14` },
  { id: 14, name: `15`, value: `15` },
  { id: 15, name: `16`, value: `16` }
];

export const APPAREL_GENDER_VALUE_MEN = 'M';
export const APPAREL_TYPE_NAME_SHOE = 'Shoe';